import React, { useMemo } from 'react';
import Select from 'react-select';
import { Colors } from '../../../../constants';
import CheckboxList from '../../../../components/forms/checkbox-list.jsx';
import LabelNumber from '../../../../components/label/label-number.jsx';
import LabelEudrProducer from '../../../../components/label/label-eudr-prod.jsx';
import NoPagination from '../../../../components/pagination/noPagination.jsx';
import colourStyles from '../../../../utils/colourStyles';
import getRiesgoEudrLabel from '../../../../nuup/utils/getRiesgoEudrLabel.js';
import { useCoopConfig } from '../../../../components/content/coop-config.jsx';
import insertIf from '../../../../utils/insertIf.js';
import getBackgroundColor from '../../../../utils/getBackgroundColor.js';
import getColor from '../../../../utils/getColor.js';

const LotesTable = ({ data, blocking, idLote, setIdLote, setInfoLote, handleNavigateToLoteDetails, estados, handlerSelectChange }) => {
  const coopConfig = useCoopConfig();

  const handleLotesCheck = (event, row) => {
    if (event.target.checked) {
      setInfoLote(row);
      setIdLote(Number(event.target.value));
    } else {
      setIdLote(0);
      setInfoLote({});
    }
  };

  const columnsLotes = useMemo(
    () => [
      {
        Header: 'INFORMACIÓN DEL LOTE',
        columns: [
          {
            Header: (
              <input
                type="checkbox"
                name="lotesAll"
                checked={false}
                onChange={() => {}}
                style={{
                  width: 20,
                  height: 20,
                  accentColor: Colors.primary_600,
                  display: 'block',
                }}
              />
            ),
            id: 'id',
            accessor: 'id',
            sortable: false,
            width: 50,
            Cell: ({ row }) => {
              return (
                <>
                  <div className="form-check">
                    <CheckboxList
                      name="lotes"
                      value={row.original.id}
                      handleCheck={event => handleLotesCheck(event, row.original)}
                      checked={idLote === Number(row.original.id)}
                    />
                  </div>
                </>
              );
            },
          },
          {
            Header: 'NOMBRE',
            accessor: 'nombre',
            sortable: true,
            minWidth: 80,
            Cell: ({ value, row }) => {
              return (
                <>
                  <a
                    onClick={() => {
                      setIdLote(Number(row.original.id));
                      handleNavigateToLoteDetails(Number(row.original.id));
                    }}
                    className="btn btn-link text-left d-inline"
                    style={{ color: Colors.primary_500 }}>
                    <span>{value}</span>
                  </a>
                </>
              );
            },
          },
          {
            Header: 'CÓDIGO',
            accessor: 'folio',
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              if (row.original.folio != null) {
                return value;
              } else {
                return '-';
              }
            },
          },
          {
            Header: `VOLUMEN TOTAL (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'volumen',
            sortable: true,
            minWidth: 50,
            show: !coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value, row }) => {
              if (row.original.volumen != null) {
                return <LabelNumber value={value} currency={false} digits={2} position="text-left"></LabelNumber>;
              } else {
                return '-';
              }
            },
          },
          {
            Header: `VOLUMEN TOTAL (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'volumen_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value, row }) => {
              if (row.original.volumen_extra != null) {
                return <LabelNumber value={value} currency={false} digits={2} position="text-left"></LabelNumber>;
              } else {
                return '-';
              }
            },
          },
          {
            Header: `VOLUMEN POR ASIGNAR (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'lote_kgs_por_entregar',
            sortable: true,
            minWidth: 50,
            show: !coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value, row }) => {
              if (row.original.lote_kgs_por_entregar != null) {
                return <LabelNumber value={value} currency={false} digits={2} position="text-left"></LabelNumber>;
              } else {
                return '-';
              }
            },
          },
          {
            Header: `VOLUMEN POR ASIGNAR (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'lote_kgs_por_entregar_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value, row }) => {
              if (row.original.lote_kgs_por_entregar_extra != null) {
                return <LabelNumber value={value} currency={false} digits={2} position="text-left"></LabelNumber>;
              } else {
                return '-';
              }
            },
          },
          {
            Header: `VOLUMEN ASIGNADO (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'lote_kgs_entregados',
            sortable: true,
            minWidth: 50,
            show: !coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value, row }) => {
              if (row.original.lote_kgs_entregados != null) {
                return <LabelNumber value={value} currency={false} digits={2} position="text-left"></LabelNumber>;
              } else {
                return '-';
              }
            },
          },
          {
            Header: `VOLUMEN ASIGNADO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'lote_kgs_entregados_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value, row }) => {
              if (row.original.lote_kgs_entregados_extra != null) {
                return <LabelNumber value={value} currency={false} digits={2} position="text-left"></LabelNumber>;
              } else {
                return '-';
              }
            },
          },
          {
            Header: 'AVANCE ACOPIO',
            accessor: 'avance_acopio',
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              let avance_por = ((Number(row.original.lote_kgs_entregados) / Number(row.original.volumen)) * 100).toFixed(2) + ' %';
              if (row.original.volumen != null) {
                return <LabelNumber value={avance_por} currency={false} suffix=" %" digits={2} position="text-left"></LabelNumber>;
              } else {
                return '-';
              }
            },
          },
          {
            Header: 'ESTADO',
            sortable: true,
            minWidth: 200,
            Cell: ({ value, row }) => {
              return (
                <Select
                  menuPortalTarget={document.body}
                  menuPosition={'fixed'}
                  key={row.original.id}
                  loading={blocking}
                  options={estados}
                  onChange={value => handlerSelectChange(value, row.original.uuid)}
                  value={estados.find(it => it.value == row.original.id_recoleccion_acopio_estatus)}
                  styles={colourStyles}
                />
              );
            },
          },
          {
            Header: 'OBSERVACIONES',
            accessor: 'observaciones',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'FECHA DE ENTREGA O VENTA',
            accessor: 'fecha_entrega_venta',
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              if (row.original.fecha_entrega_venta != null) {
                return value;
              } else {
                return '-';
              }
            },
          },
          {
            Header: 'RIESGO EUDR',
            accessor: 'riesgo_eudr',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig.config?.usa_eudr,
            Cell: ({ value }) => <LabelEudrProducer riesgo={getRiesgoEudrLabel(value)} />,
          },
        ],
      },
      ...insertIf(!!+coopConfig.config?.usa_calidad, {
        Header: 'RESULTADOS DE MUESTREO',
        columns: [
          { Header: 'ID MUESTRA', accessor: 'id_muestra', sortable: true, minWidth: 50 },
          { Header: 'TIPO DE MUESTRA', accessor: 'nombre_tipo_muestra', sortable: true, minWidth: 80 },
          {
            Header: 'RENDIMIENTO BRUTO (%)',
            accessor: 'rendimiento_bruto',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} />,
          },
          {
            Header: 'RENDIMIENTO EXPORTABLE (%)',
            accessor: 'rendimiento_exportable_por',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} />,
          },
          {
            Header: 'RENDIMIENTO REAL (%)',
            accessor: 'rendimiento_real',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} />,
          },
          {
            Header: 'PUNTAJE EN TAZA',
            accessor: 'puntaje_manual',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} />,
          },
        ],
      }),
    ],
    [estados, idLote, blocking, coopConfig]
  );

  return (
    <NoPagination
      blocking={blocking}
      selected="id"
      columns={columnsLotes}
      data={data}
      fnBackgroundColor={getBackgroundColor}
      fnColor={getColor}
    />
  );
};

export default LotesTable;
